import { useQuery, UseQueryOptions } from 'react-query';
import { gql, GraphQLClient } from 'graphql-request';
// import oktaAuth from 'src/config/oktaConfig';

const SAGE_API_BASE_URL =
  process.env.REACT_APP_SAGE_RISK_ASSESSMENTS_API_BASE_URL ?? '';
const graphQLClient = new GraphQLClient(SAGE_API_BASE_URL);

export interface GraphQlConfig {
  query: string;
  variables?: any;
  //REVIEW - Add types for headers?
  headers?: any;
}

export const useGraphQLQuery = (
  queryIdentifier: any,
  graphqlConfig: GraphQlConfig,
  options?:
    | Omit<UseQueryOptions<any, unknown, any, any>, 'queryKey' | 'queryFn'>
    | undefined,
) => {
  //   const token = oktaAuth.getAccessToken();
  const headers = {
    ...graphqlConfig.headers,
    // authorization: token ? `Bearer ${token}` : '',
  };
  return useQuery(
    queryIdentifier,
    async () => {
      const { query, variables = {} } = graphqlConfig;
      const response = await graphQLClient.request(
        gql`
          ${query}
        `,
        { ...variables },
        { ...headers },
      );
      return response;
    },
    options,
  );
};
